import axios, { AxiosError } from 'axios';
import { successTemp } from './component/successTemp';
import { ApiErrorData, getErrorMessage, getErrorResult } from './common/errorMessageUtil';
import { caseMapDoToSi } from './common/mapDoToSi';
import { callGetPlayer, callGetSurveyFlag, callPostSurvey } from './services';
// import './util/cert2.js';
import { mergeSearchParams, removeQueryParam, setAnchorTagWithParams } from './common/common_util';
import { DEFAULT_ERROR_MESSAGE, ERROR_CODE_TO_MESSAGE_MAPPED } from './common/errorCode';
import { dataSuervey1, dataSuervey2 } from './model';


const EVETN_CODE = 'test-1';
const IS_OVER_SCHEDULE_SURVEY = new Date() >= new Date('2023-06-04T23:59');

// [TODO] FORM1 / FORM2 다른값
let SURVEY_NO: 1 | 2;
let SURVEY_DATA_MODEL: typeof dataSuervey1 | typeof dataSuervey2;

// const SURVEY_NO = 2;s
// const SURVEY_DATA_MODEL = dataSuervey2;

// const WSTATIC_IMGA_PATH = window.wstaticDomain;

const URL_INFO_PAGE = mergeSearchParams(window.urlInfoPage, location.href);

const INVLALID_PHONE = 'invalid-phone';
const INVLALID_EMAIL = 'invalid-email';
const INVLALID_BIRTH = 'invalid-birth';
const INVLALID_BIRTH_AGE = 'invalid-birth-age';
const NO_SETTILE_SURVEY = 'invalid-survey';
const NO_SETTILE_AGREE = 'invalid-agree';
const NO_SETTILE_SURVEY_CURRENT_PAGING = 'invalid-survey-current-paging';
const NO_SETTILE_CERT_RESULT = 'invalid-cert';
const NO_SETTILE_USERINFO = 'invalid-userinfo';

const INVLALID_PHONE_MEASSAGE = '올바른 핸드폰 번호를 입력해 주세요';
const INVLALID_EMAIL_MEASSAGE = '올바른 이메일 주소를 입력해 주세요';
const INVLALID_BIRTH_MEASSAGE = '올바른 생일을 입력해 주세요';
const INVLALID_BIRTH_AGE_MEASSAGE = '2003년 1월 26일 이전 출생자까지 신청하실 수 있습니다.';

const NO_SETTLE_SURVEY_MEASSAGE = '모든 설문 항목 입력 후 최종제출이 가능합니다.';
const NO_SETTLE_SURVEY_CURRENT_PAGING_MEASSAGE = '모든 설문을 입력해 주세요.';
// const NO_SETTLE_AGREE_MEASSAGE = '모든 동의항목을 체크해 주세요';
const NO_SETTLE_AGREE_MEASSAGE = '모든 설문 항목 입력 후 최종제출이 가능합니다.';
// const NO_SETTLE_REQUIRED_AGREE_CHECKBOX_MEASSAGE = '필수 동의 항목을 모두 동의해주세요 (checkbox)';
// const NO_SETTLE_REQUIRED_AGREE_RADIO_MEASSAGE = '필수 동의 항목을 모두 동의해주세요 (radio)';
// const NO_SETTLE_REQUIRED_AGREE_CHECKBOX_MEASSAGE = '필수 동의 항목을 모두 동의해주세요';
// const NO_SETTLE_REQUIRED_AGREE_RADIO_MEASSAGE = '필수 동의 항목을 모두 동의해주세요';
const NO_SETTLE_REQUIRED_AGREE_CHECKBOX_MEASSAGE = '모든 설문 항목 입력 후 최종제출이 가능합니다.';
// const NO_SETTLE_REQUIRED_AGREE_RADIO_MEASSAGE = '필수 동의 항목을 모두 동의해주세요';
const NO_SETTLE_REQUIRED_AGREE_RADIO_MEASSAGE = '모든 설문 항목 입력 후 최종제출이 가능합니다.';

// const NO_SETTILE_CERT_RESULT_MEASSAGE = '본인인증을 먼저 진행해 주세요.';
const NO_SETTILE_CERT_RESULT_MEASSAGE = '필수 항목을 입력 후 신청이 가능합니다.';

const NO_SETTLE_USERINFO_MEASSAGE = '모두 항목을 작성해 주세요';

const ALREADY_APPILIED = '이미 FINAL TEST를 신청한 계정입니다';

const CONFIRM_MESSAGE = '최종제출 후 수정이 불가능하니, 재 확인 부탁드립니다.';

const BTN_CERT_TEXT_BEFORE = '휴대폰 본인 인증';
const BTN_CERT_TEXT_AFTER = '본인인증 정보 변경';

let CURRENT_PAGE = 0;


// DOM register
let elRegistrationWrap: HTMLDivElement;

// DOM agree
let elAgreeCheckboxs: NodeListOf<HTMLInputElement>;
let elAgreeRadios: NodeListOf<HTMLInputElement>;

// DOM userinfo
// let elUserInfo: NodeListOf<HTMLInputElement>;
// let elUserInfoName: HTMLInputElement;
// let elUserInfoBirth: HTMLInputElement;
// let elUserInfoPhone: HTMLInputElement;
// let elUserInfoEmail: HTMLInputElement;

// DOM Cert
let elBtnCert: HTMLButtonElement;
let elCertNotice: HTMLParagraphElement;
let elCertInfoWrap: HTMLDivElement;
let elCertInfoName: HTMLParagraphElement;
let elCertInfoPhone: HTMLParagraphElement;
let elCertInfoBirth: HTMLParagraphElement;
const certInfoName = '';
const certInfoPhone = '';
const certInfoBirth = '';


let elCertAddress1: HTMLSelectElement;
let elCertAddress2: HTMLSelectElement;
const HAS_CERT_RESULT = false;

// DOM survey
let elSurveyCheckboxs: NodeListOf<HTMLInputElement>; // input-survey[type="checkbox"],
let elSurveyRadios: NodeListOf<HTMLInputElement>; // input-survey[type="radio"],
let elSurveyTextAreas: NodeListOf<HTMLTextAreaElement>; // textarea-survey;

let elFormWrap: NodeListOf<HTMLFormElement>;
let elBtnSubmit: HTMLButtonElement;
let elSubmitWrongMessage: HTMLParagraphElement;

// survey name
let nameSurveyCheckboxs: Set<string>;
let nameSurveyRadios: Set<string>;
let nameSurveyTextareas: Set<string>;

// DOM sucess
let elSuccessWrap: HTMLDivElement;

// DOM modal
let elModalConfirm: HTMLDivElement;
let elModalAlready: HTMLDivElement;
let elModalDimmed: HTMLDivElement;
let selectorModalCofirm: string;
let selectorModalAlready: string;
let selectorModalUnderage: string;

let elPageSection: NodeListOf<HTMLDivElement>;
let elBtnPrevPage: HTMLButtonElement;
let elBtnNextPage: HTMLButtonElement;
let elPageInfo: HTMLDivElement;

let ncuiToast: any;
let ncuiConfirm: any;
let ncuiAlert: any;

const inputSurveyData: Map<string, string | undefined> = new Map();

// document.addEventListener('DOMContentLoaded', () => {
//   // if(!redirectToMain())

//   init();
// });

export async function init(surveyNo: 1 | 2, surverDataModel: typeof dataSuervey1 | typeof dataSuervey2) {

  (document.querySelector('.content') as HTMLDivElement).style.display = 'none';

  SURVEY_NO = surveyNo;
  SURVEY_DATA_MODEL= surverDataModel;

  setTitle();
  // 로그인 여부 확인 - 바닦에서 하고 있음 - 주석 안풀어도 됨
  // checkLogin();

  // 설문 템플릿 만들기
  // createFormData2(dataSuervey2);
  createFormData(SURVEY_DATA_MODEL);

  // 변수 세팅
  setElementVariable();

  // 설문 기간인지 확인
  if(IS_OVER_SCHEDULE_SURVEY){
    await ncuiAlert.open({
      title: '이벤트 기간이 아닙니다.',
      confirmButtonText: '확인',
    });

    location.href = URL_INFO_PAGE;
    return;
  }


  // 이미 설문 완료 했는지 확인
  if (await checkIsAlreadyCompleteSurvey()) {
    await ncuiAlert.open({
      title: ERROR_CODE_TO_MESSAGE_MAPPED['alreadyCompleteSurvey'],
      confirmButtonText: '확인',
    });

    location.href = URL_INFO_PAGE;
    return;
  }

  if(await checkIsNotAuthorityToSurvey()){
    await ncuiAlert.open({
      title: ERROR_CODE_TO_MESSAGE_MAPPED['under_level'],
      confirmButtonText: '확인',
    });

    location.href = URL_INFO_PAGE;
    return;
  }

  // 쿼리스트링 물고 있는 경우 본인인증 했는지 확인 -> 본인인증 프로세스의 리턴 url(모바일)
  // await checkCertAuthByQuery();

  // [TODO] 삭제
  // HAS_CERT_RESULT = true;

  // 초기 세팅
  setSurveyData();
  setBtnSubmitDisable(); // 제출 버튼 디스에이블
  setDisablePagingNavigator(); // 페이지 버튼 디스에이블

  setPaging(0);
  // 초기 세팅 - 본인인증
  // setSurveyDisable();
  // setCertArea();

  // a 태그의 파리미터에 querystring 물고 가기
  setAnchorTagHrefWithcUrrentParam();

  // 이벤트 바인딩
  eventBinding();

  (document.querySelector('.content') as HTMLDivElement).style.display = 'block';

  window.addEventListener('beforeunload', callbackBerforeunload);

}

function setTitle(){
  let title: string;

  if(SURVEY_NO === 1){
    title = '10레벨 달성 설문 (총 12문항)';
  }else{
    title = '22레벨 달성 설문 (총 23문항)';
  }

  document.querySelector('.section-top-text h2')!.innerHTML = title;
}

/**
 * Tracking 코드
 */
function setTrackingCode() {
  // 신청하기 버튼
  elBtnSubmit.addEventListener('click', () => {
    //   window.dataLayer.push({
    //     'event': 'customEvent',
    //     'customEventCategory': '클릭',
    //     'customEventAction': 'Content Container - 버튼 클릭',
    //     'customEventLabel': '클릭 컨텐츠 : final test 2단계'
    //   });
  });


  // 신청 완료하시면, 수정이 불가능합니다. 다시 확인 하시겠습니까?
  document.querySelector('.modal-confirm .btn-modal-confirm')?.addEventListener('click', () => {
    // [6]
    try {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-11010511490/aGbzCJHP9JcYEIKlnIIp',
        'value': 5000.0,
        'currency': 'KRW',
      });
    } catch {
      //
    }
  });
}
function sendTrackingCodeSucess(id?: string) {
  console.log(id);

  window._sendTrackingCodeSucess(id);
}

function checkLogin() {
  if (window.isLoginFlag === false || window.isLoginFlag === 'false') {
    // 리다이렉트
    window.GNBLogin();
  }
}



function setElementVariable() {

  elRegistrationWrap = document.querySelector('.registration-wrap') as HTMLDivElement;
  elSuccessWrap = document.querySelector('.success-wrap') as HTMLDivElement;
  elModalConfirm = document.querySelector('.modal-confirm') as HTMLDivElement;
  elModalAlready = document.querySelector('.modal-already') as HTMLDivElement;
  elModalDimmed = document.querySelector('.modal-dimmed') as HTMLDivElement;

  elBtnCert = document.querySelector('#btnCert') as HTMLButtonElement;
  elCertNotice = document.querySelector('.cert-notice') as HTMLParagraphElement;
  elCertInfoWrap = document.querySelector('.cert-info-wrap') as HTMLDivElement;
  elCertInfoName = document.querySelector('.cert-info-row-name .cert-info-value') as HTMLDivElement;
  elCertInfoPhone = document.querySelector('.cert-info-row-phone .cert-info-value') as HTMLDivElement;
  elCertInfoBirth = document.querySelector('.cert-info-row-birth .cert-info-value') as HTMLDivElement;
  /*
  elCertAddress1 = document.querySelector('#address1') as HTMLSelectElement;
  elCertAddress2 = document.querySelector('#address2') as HTMLSelectElement;
  */

  elAgreeCheckboxs = document.querySelectorAll('input.input-agree[type="checkbox"]') as NodeListOf<HTMLInputElement>;
  elAgreeRadios = document.querySelectorAll('input.input-agree[type="radio"]') as NodeListOf<HTMLInputElement>;

  elSurveyCheckboxs = document.querySelectorAll('input.input-survey[type="checkbox"]') as NodeListOf<HTMLInputElement>;
  elSurveyRadios = document.querySelectorAll('input.input-survey[type="radio"]') as NodeListOf<HTMLInputElement>;
  elSurveyTextAreas = document.querySelectorAll('textarea.textarea-survey') as NodeListOf<HTMLTextAreaElement>;

  nameSurveyCheckboxs = getInputNames(elSurveyCheckboxs);
  nameSurveyRadios = getInputNames(elSurveyRadios);
  nameSurveyTextareas = getInputNames(elSurveyTextAreas);

  // elUserInfo = document.querySelectorAll('.input-userinfo') as NodeListOf<HTMLInputElement>;
  // elUserInfoName = document.querySelector('.input-userinfo[name="userinfo-name"]') as HTMLInputElement;
  // elUserInfoBirth = document.querySelector('.input-userinfo[name="userinfo-birth"]') as HTMLInputElement;
  // elUserInfoPhone = document.querySelector('.input-userinfo[name="userinfo-phone"]') as HTMLInputElement;
  // elUserInfoEmail = document.querySelector('.input-userinfo[name="userinfo-email"]') as HTMLInputElement;

  elBtnSubmit = document.querySelector('.btn-submit-wrap .btn-submit') as HTMLButtonElement;
  elSubmitWrongMessage = document.querySelector('.btn-submit-wrap p') as HTMLParagraphElement;
  elFormWrap = document.querySelectorAll('.form-wrap') as NodeListOf<HTMLFormElement>;

  selectorModalCofirm = '.modal-confirm-submit';
  selectorModalAlready = '.modal-already';
  selectorModalUnderage = '.modal-underage';

  elPageSection = document.querySelectorAll('.section-page') as NodeListOf<HTMLDivElement>;
  elBtnNextPage = document.querySelector('.next-page') as HTMLButtonElement;
  elBtnPrevPage = document.querySelector('.prev-page') as HTMLButtonElement;
  elPageInfo = document.querySelector('.paging-info') as HTMLDivElement;

  // ncui.modal
  ncuiToast = new window.ncui.modal.uiToast();
  ncuiConfirm = new window.ncui.modal.uiConfirm();
  ncuiAlert = new window.ncui.modal.uiAlert();

  console.log(elSurveyCheckboxs, elSurveyRadios, elSurveyTextAreas);
  console.log(nameSurveyCheckboxs, nameSurveyRadios, nameSurveyTextareas);
}

function getInputNames(nodeList: NodeListOf<HTMLInputElement | HTMLTextAreaElement>) {
  const tet = new Set([...nodeList].map(el => {
    return el.name;
  }));

  return tet;
}



/*
async function checkCbtApplyStatus() {
  let newUrl = mergeSearchParams(window.urlInfoPage, location.href);
  newUrl = removeQueryParam(newUrl, 'q');

  try {
    const result = (await callCheckCbtApplyStatus(EVETN_CODE)).data;
    console.log(result);


    if (result.eventCode) {

      // window.alert(ALREADY_APPILIED);
      await confirmAlert(selectorModalAlready);

      window.location.href = newUrl;

      return false;
    } else {
      return true;
    }
  } catch (error) {
    if (axios.isAxiosError<ApiErrorData>(error)) {
      displayErrorMessage(error);
      window.location.href = newUrl;
    }
  }
}
*/

async function checkIsAlreadyCompleteSurvey(){
  const result = await sendCallGetSurveyFlag();
  if(!result){
    location.reload();
    return;
  }

  if(result.surveyFlagMap[SURVEY_NO]){
    return true;
  }else{
    return false;
  }
}

async function checkIsNotAuthorityToSurvey(){
  const levelStandard = SURVEY_NO === 1 ? 10 : 22;

  const result = await sendCallGetPlayer();
  if(!result){
    location.reload();
    return;
  }

  if(result.level < levelStandard){
    return true;
  }else{
    return false;
  }
}


// 설문 조사 여부 정보 조회
async function sendCallGetSurveyFlag(): Promise<ResponseGetSurveyFlagData | false>{
  try{

    const result = (await callGetSurveyFlag({eventCode: EVETN_CODE})).data;
    // const result = {surveyFlagMap:{
    //   0: true,
    //   1: true,
    //   2: true // 이거
    // }};

    return result;
  }catch(error){
    if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});

      await ncuiAlert.open({
        title: errorMessage,
        confirmButtonText: '확인',
      });

      return false;
    }else{
      throw error;
    }
  }
}



// 게임 플레이 정보 조회
async function sendCallGetPlayer(): Promise<ResponseGetPlayerData | false>{
  try{
    const result = (await callGetPlayer({eventCode: EVETN_CODE})).data;
    // const result = {
    //   level: 19,
    //   count: 5,
    //   logDate: '',
    //   couponMap: {
    //     '1': '123123123',
    //     '2': '123123123',
    //     '3': '123123123',
    //     '4': '',
    //     '5': '',
    //     '6': '',
    //     '101': '123123123',
    //     '102': '',
    //   }
    // };

    return result;
  }catch(error){
    if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});

      ncuiAlert.open({
        title: errorMessage,
        confirmButtonText: '확인',
      });

      return false;
    }else{
      throw error;
    }
  }
}


async function sendSuervery() {
  try {
    const data = getAPIData();


    const result = await callPostSurvey(data);

    console.log(result);
    // 신청 성공
    // sendTrackingCodeSucess(result.data.id);


    await confirmConfirm({
      title:'설문 제출이 완료되었습니다.',
      html: '설문에 참여해 주셔서 감사합니다.',
      showCancelButton: false,
      confirmButtonText: '확인',
      customClass: 'sucess-modal'
    });


    resetInput();

    const URL_INFO_PAGE_WITH_HASH = (new URL(URL_INFO_PAGE));
    URL_INFO_PAGE_WITH_HASH.hash = 'surveySection';

    window.removeEventListener('beforeunload', callbackBerforeunload);

    location.href=URL_INFO_PAGE_WITH_HASH.href;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorData = (error).response.data;
      if (!errorData) return false;

      const errorMessage = getErrorMessage(errorData, ERROR_CODE_TO_MESSAGE_MAPPED);

      // toggleSubmitWrongMessage(true, errorMessage);

      alert(errorMessage);
    }
  }
}

function callbackBerforeunload(event: BeforeUnloadEvent) {
  return  event.returnValue = '';
}

// function showSucessSection() {

//   elRegistrationWrap.innerHTML = '';
//   elRegistrationWrap.innerHTML = successTemp;
//   window.scroll({ top: 0, behavior: 'smooth', });

//   // setAnchorTagWithParams(document.querySelectorAll('a'));
//   [...document.querySelectorAll('a')].map(ElAnchor => setAnchorTagWithParams(ElAnchor));

//   document.querySelector('.btn-go-brand')?.addEventListener('click', () => {
//     console.log('click btn-go-brand');
//     window.dataLayer.push({
//       'event': 'customEvent',
//       'customEventCategory': '클릭',
//       'customEventAction': 'Content Container - 버튼 클릭',
//       'customEventLabel': '4단계브랜드사이트바로가기'
//     });
//   });

// }

function eventBinding() {
  // checkbox 이벤트
  [...elSurveyCheckboxs, ...elSurveyRadios, ...elAgreeCheckboxs, ...elAgreeRadios].map(
    el => el.addEventListener('change', onChangeInput)
  );

  // textArea 이벤트, elUserInfo 이벤트
  [...elSurveyTextAreas, /*...elUserInfo*/].map(
    el => el.addEventListener('input', onChangeInput)
  );

  // checkbox value에 no 가 있는 항목은 no 선택시 다른거 다 지움
  ([...document.querySelectorAll('[name="survey-prefer-mostnc"], [name="preferMo"]')] as [HTMLInputElement]).map(
    el => el.addEventListener('change', exceptNoneValue)
  );

  // checkbox 선택 최대 개수 넘어가면 나머지 disabled - 아 귀찮아.................................................리엑트 씁시다.
  // ([...document.querySelectorAll('[data-check-max] [type="checkbox"]')]).map(
  //   el => el.addEventListener('change', (e)=>{
  //     const maxChecked = ((e.target as HTMLInputElement).closest('[data-check-max]') as HTMLElement).dataset.checkMax;

  //     const targetName = (e.target as HTMLInputElement).name;

  //     const elAll = document.querySelectorAll(`[name=${targetName}]`) as NodeListOf<HTMLInputElement>;
  //     const elChecked = [...elAll].filter(el=>el.checked);
  //     const elUnChecked = [...elAll].filter(el=>!el.checked);
  //     const elNone = [...elAll].filter(el=>el.value === 'none');

  //     // ...
  //     const elUncheckedEtcTextArea = [...elUnChecked].map(e => (e.closest('.ui-checkbox')?.querySelector('textarea')));

  //     if(elChecked.length >= Number(maxChecked)){
  //       [...elUnChecked].map(el=>el.setAttribute('disabled', 'true'));
  //       [...elUncheckedEtcTextArea].map(el=>el?.setAttribute('disabled', 'true'));

  //       [...elNone].map(el=>el?.removeAttribute('disabled')); // none value값을 살려 놔야함
  //     }else{
  //       [...elAll].map(el=>el.removeAttribute('disabled'));
  //       [...elUncheckedEtcTextArea].map(el=>el?.removeAttribute('disabled'));
  //     }
  //   })
  // );

  // 아........... checkbox 선택 최대 개수 넘어가면 처음 선택한거 지우고, 마지막에 선택한거 선태....으로 변경... 리엑트 씁시다
  const mapCheckboxNameToSelected: Record<string, HTMLInputElement[]> = {};

  ([...document.querySelectorAll('[data-check-max] [type="checkbox"]')]).map(el => {
    el.addEventListener('change', (e) => {
      const currentEl = e.target as HTMLInputElement;
      const name = currentEl.name;
      const id = currentEl.id;
      const maxChecked = ((e.target as HTMLInputElement).closest('[data-check-max]') as HTMLElement).dataset.checkMax;

      const isChecked = currentEl.checked;
      if (isChecked) {
        // 체크 true 인데, 이미 있는 거면 린턴 false
        if (mapCheckboxNameToSelected[name] && mapCheckboxNameToSelected[name].find(e => e.id === id)) return;

        // 아직 아무것도 체크 안했으면..
        if (!mapCheckboxNameToSelected[name] || mapCheckboxNameToSelected[name].length < 1) {
          mapCheckboxNameToSelected[name] = [currentEl];

          // 최대 선택 개수가 넘어 갔으면
        } else if (mapCheckboxNameToSelected[name].length >= Number(maxChecked)) {
          mapCheckboxNameToSelected[name][0].checked = false;
          mapCheckboxNameToSelected[name].shift();

          mapCheckboxNameToSelected[name].push(currentEl);

          // 그냥 노멀 하면
        } else {
          mapCheckboxNameToSelected[name].push(currentEl);
        }
      } else {
        // 체크 false 인경우
        mapCheckboxNameToSelected[name] = mapCheckboxNameToSelected[name].filter(e => e.id !== id);
      }

      // 어떠한 경우에도 일단 업데이트
      onChangeInput();
    });
  });

  ([...document.querySelectorAll('.ui-checkbox-etc-text .input-survey')] as [HTMLInputElement]).map(el => {
    el.addEventListener('change', (evt: Event) => {
      const is_checked = (evt.currentTarget as HTMLInputElement).checked;
      if(is_checked){
        (evt.currentTarget as HTMLInputElement).closest('.ui-checkbox')!.querySelector('textarea')!.focus();
      }
    });
  });

  // 체크박스중 텍스트에어리어 가지고 있는 체크박스 - 기타(직접 입력 항목)
  ([...document.querySelectorAll('.checkbox-etc-text')] as [HTMLTextAreaElement]).map(el => {

    // 입력하고 있으면, 관련 checkbox의 check상태를 true 변경 및 checkbox의 value 변경
    el.addEventListener('input', evt => {
      const elTarget = (evt.target as HTMLTextAreaElement);
      const targetCheckbox = elTarget.closest('.ui-checkbox')!.querySelector('input')!;

      targetCheckbox.checked = true;

      // 아...
      if(elTarget.value){
        targetCheckbox.value = elTarget.value;
      }else{
        targetCheckbox.value = 'null_extratext';
      }

      targetCheckbox.dispatchEvent(new Event('change'));


    });
  });

  //  페이지 버튼
  elBtnNextPage.addEventListener('click', () => {
    onClickBtnNextPage();
  });
  elBtnPrevPage.addEventListener('click', () => {
    onClickBtnPrevPage();
  });

  /*
  // 본인인증 버튼 클릭
  elBtnCert.addEventListener('click', async (evt) => {
    try {

      const returnUrl = location.href;
      const callback = 'window.checkCertAuthByCallback';

      // 본인 인증 요청 문자열 생성
      const { authRequest } = (await callCreateAuthRequest({
        returnUrl,
        callback
      })).data;

      // 본인인증 창 실행
      window.Cert.openCertWindow(authRequest);

    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorData = (error).response?.data;
        if (!errorData) return false;

        // 애러나면 일단 리로드
        // location.reload();
      }
      throw error;
    }

  });
*/

  // 본인인증을 위한 주소1번 변경
  // elCertAddress1.addEventListener('change', (evt)=>{
  //   // const elCertAddress1 = (evt.target as HTMLSelectElement);
  //   const elTargetAdd2Options = caseMapDoToSi(elCertAddress1.value);

  //   elCertAddress2.innerHTML = elTargetAdd2Options;
  // });

  // elUserInfoName.addEventListener('input', (evt) => {
  //   allowOnlyKoEnInput(evt);
  // });

  // elUserInfoPhone.addEventListener('input', (evt) => {
  //   allowOnlyNumberInput(evt, 11);
  //   insertDash(evt,[3, 8]);

  // });

  // elUserInfoBirth.addEventListener('input', (evt) => {
  //   allowOnlyNumberInput(evt, 8);
  //   insertDash(evt,[4, 7]);
  // });


  elBtnSubmit.addEventListener('click', async () => {
    if ( !isValidateAllInput() || !await confirmConfirm({
      title:'신청 완료하시면,<br>수정이 불가능합니다.<br> 다시 확인 하시겠습니까?</p>',
      // showCancelButton: false,
      confirmButtonText: '신청하기',
      cancelButtonText: '수정하기',
    }) ) return false;


    await sendSuervery();
  });

  document.querySelector('.logout')?.addEventListener('click', () => {
    window.GNBLogout();
  });


  // 마케팅 동의
  /*
  [...elAgreeCheckboxs, ...elAgreeRadios].filter(e=>e.dataset.optional).forEach(el => el.addEventListener('change', ()=>{
    const flag = el.value === 'agree';

    showMarketingApplyAlert(flag);
  }));
  */

  setTrackingCode();
}

function resetInput() {
  elFormWrap.forEach(e => e.reset()); // form 리셋
  setSurveyData(); // 서베이 데이터 리셋
  setBtnSubmitDisable(); // 버튼 디스에이블

  setDisablePagingNavigator(); // 페이지 버튼 디스에이블
}

function onChangeInput() {
  setSurveyData(); // 서베이 데이터 세팅
  setBtnSubmitDisable(); // 신청하기 버튼 disable 세팅

  setDisablePagingNavigator(); // 페이지 버튼 디스에이블
}


function setBtnSubmitDisable() {
  try {
    isSettledAllInput();

    toggleBtnSibmitDisable(false);
    toggleSubmitWrongMessage(false);

    // 오류 아닌데.....! 원래 오류만 넣는 함수였는데...!
    toggleSubmitWrongMessage(true, CONFIRM_MESSAGE);
  } catch (error) {
    if (!isValidationError(error)) throw error;

    toggleBtnSibmitDisable(true);
    // toggleSubmitWrongMessage(true, '모든 항목을 입력 후 신청이 가능합니다.');
    toggleSubmitWrongMessage(true, error.message);


    // 애러 처리
    handleValidationError(error);
  }
}

function toggleSubmitWrongMessage(flag: boolean, message?: string) {
  if (message) {
    elSubmitWrongMessage.innerHTML = message;
  }

  if (flag) {
    elSubmitWrongMessage.style.display = 'block';
  } else {
    elSubmitWrongMessage.style.display = 'none';
  }
}

function toggleBtnSibmitDisable(flag: boolean) {
  if (flag) {
    elBtnSubmit.disabled = true;
    console.log('버튼 비 활성화!');
  } else {
    elBtnSubmit.disabled = false;
    console.log('버튼 활성화!');
  }
}

function alertPleaseTryCert() {
  // alert(NO_SETTILE_CERT_RESULT_MEASSAGE);
  // window.scroll({ top: 0, behavior: 'smooth', });

  confirmConfirm({title:''});
}

/*
function setCertArea() {
  if (HAS_CERT_RESULT) {
    // 버튼 텍스트
    // elBtnCert.innerText = BTN_CERT_TEXT_AFTER;
    // 버튼 디스플레이
    elBtnCert.style.display = 'none';
    // 주의 사항
    elCertNotice.style.display = 'none';
    // 정보
    elCertInfoWrap.style.display = 'flex';

    // 스타일
    document.querySelector('.section-area-cert')?.classList.add('sucess-cert');

    // 정보 입력
    // elCertInfoBirth.innerText  = certInfoBirth;
    // elCertInfoName.innerText = certInfoName;
    // elCertInfoPhone.innerText  = certInfoPhone;

  } else {
    // 버튼 텍스트
    // elBtnCert.innerText = BTN_CERT_TEXT_BEFORE;
    // 버튼 디스플레이
    elBtnCert.style.display = '';
    // 주의 사항
    elCertNotice.style.display = 'flex';
    // 정보
    elCertInfoWrap.style.display = 'none';
    // 스타일
    document.querySelector('.section-area-cert')?.classList.remove('sucess-cert');

  }
}
*/

// function setSurveyDisable() {
//   if (HAS_CERT_RESULT) {
//     [...elSurveyCheckboxs, ...elSurveyRadios, ...elSurveyTextAreas, ...elAgreeCheckboxs, ...elAgreeRadios /* elCertAddress1, elCertAddress2 */].map(el => {
//       el.disabled = false;

//       // 라벨 클릭시 얼럿 - cheeckbox, radio
//       el.closest('div')?.querySelector('label')?.removeEventListener('click', alertPleaseTryCert);

//       // checkbox 인데 textarea를 가지고 있는경우
//       el.closest('div')?.querySelector('textarea')?.removeAttribute('disabled');

//       // textarea 의 경우
//       if(el instanceof HTMLTextAreaElement){
//         el.closest('div')?.removeEventListener('click', alertPleaseTryCert);
//       }

//       // [TODO] elCertAddress에 label 넣을건지
//     });
//     console.log('설문 활성화!');
//   } else {
//     [...elSurveyCheckboxs, ...elSurveyRadios, ...elSurveyTextAreas, ...elAgreeCheckboxs, ...elAgreeRadios /* elCertAddress1, elCertAddress2 */].map(el => {
//       el.disabled = true;

//       // 라벨 클릭시 얼럿 - cheeckbox, radio
//       el.closest('div')?.querySelector('label')?.addEventListener('click', alertPleaseTryCert);

//       // checkbox 인데 textarea를 가지고 있는경우
//       el.closest('div')?.querySelector('textarea')?.setAttribute('disabled', 'true');

//       // textarea 의 경우
//       if(el instanceof HTMLTextAreaElement){
//         el.closest('div')?.addEventListener('click', alertPleaseTryCert);
//       }
//       // [TODO] elCertAddress에 label 넣을건지
//     });
//     console.log('설문 비 활성화!');
//   }
// }


/*
* 유저정보 유효성 검사 관련(생일 전화번호 등..)

function getStandardBirthdate(standardAge:number, standardDate: Date = new Date()){
  const age = standardAge;
  const nowYear = standardDate.getFullYear();
  const nowMonth = standardDate.getMonth();
  const nowDay = standardDate.getDate();

  return new Date(nowYear - age, nowMonth, nowDay);
}

function checkValidationEmail(){
  const email = elUserInfoEmail.value;
  const regExpEmail = /^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g;

  const result = regExpEmail.test(email);
  if(!result){
    throw({invalidType: INVLALID_EMAIL, message: INVLALID_EMAIL_MEASSAGE});
  }
  return true;
}


function checkValidationPhone(){
  const phone = allowOnlyNumber(elUserInfoPhone.value);
  console.log('전화번호', phone);

  const regExpNum = /(^010|019|018|011|017)[0-9]{7,8}/;
  const result = regExpNum.test(phone);
  if(!result){
    throw({invalidType: INVLALID_PHONE, message: INVLALID_PHONE_MEASSAGE});
  }

  return true;
}

function checkValidationBirthDay(){
  const birth = allowOnlyNumber(elUserInfoBirth.value);
  console.log('생일', birth);

  // 유효성 검사 - 정규식
  // const regExpBirth = /(19|20)[0-9]{2}(0[1-9]|1[0-2])([0][1-9]|[1-2][0-9]|3[0-1])/g;
  // if(!regExpBirth.test(birth)) {
  //   console.log(birth);
  //   throw({invalidType: INVLALID_BIRTH, message: INVLALID_BIRTH_MEASSAGE});
  // }

  // 유효성 검사 - 숫자로
  const inputedYear = Number(birth.substring(0, 4));
  const inputedMonth = Number(birth.substring(4, 6));
  const inputedDate = Number(birth.substring(6));

  if(
    (inputedYear < 1900 ) ||
    (inputedMonth < 1 || inputedMonth > 12 ) ||
    (inputedDate < 1 || inputedDate > 31) ||
    (inputedMonth === 2 && inputedDate > 29)
  ){
    throw({invalidType: INVLALID_BIRTH, message: INVLALID_BIRTH_MEASSAGE});
  }

  // 만 18세 인지
  const inputBirthDate = new Date( Number(birth.substring(0, 4)), Number(birth.substring(4, 6))-1, Number(birth.substring(6)) );
  const standardBirthdate = getStandardBirthdate(20, new Date('2023-01-26'));
  console.log('standardBirthdate: ', standardBirthdate, 'inputBirthDate: ', inputBirthDate);

  if( standardBirthdate < inputBirthDate) {
    throw({invalidType: INVLALID_BIRTH_AGE, message: INVLALID_BIRTH_AGE_MEASSAGE});
  }

  return true;
}


function changePhonenumberStringToNum(num){
  const regExpNum = /010|019|018|011|017[0-9]{7,8}/g;
  const result = num.test(elUserInfoPhone.value);
}

function allowOnlyNumber(str: string) {
  const noNumRegExpNum = /[^0-9]/g;
  return str.replace(noNumRegExpNum, '');
}

function allowOnlyNumberInput(evt: Event, max?: number) {
  const elTarget = evt.target;
  if (!(elTarget instanceof HTMLInputElement)) return;

  console.log(elTarget.value);

  elTarget.value = allowOnlyNumber(elTarget.value).substring(0, max || elTarget.value.length);
}

function insertDash(evt: Event, targetIdxs: number[]) {
  const elTarget = evt.target;
  if (!(elTarget instanceof HTMLInputElement)) return;

  const DASH = '-';

  elTarget.value = targetIdxs.reduce((newValue, targetIdx) => {
    if (newValue.length > targetIdx) {
      newValue = newValue.slice(0, targetIdx) + DASH + newValue.slice(targetIdx);
    }

    return newValue;

  }, elTarget.value);
}

function allowOnlyKoEnInput(evt: Event) {
  console.log(evt);
  const elTarget = evt.target;
  if (!(elTarget instanceof HTMLInputElement)) return;

  console.log(elTarget.value);

  const noNumRegExpNum = /[^a-z|A-Z|ㄱ-ㅎ|가-힣]/g;
  elTarget.value = elTarget.value.replace(noNumRegExpNum, '');
}

*/

function print(obj: Record<string, any>) {
  console.log(JSON.stringify(obj, null, 4));
}

function setSurveyData() {
  setSurveyDataCheckbox();
  setServeyDataRadio();
  setSurveyDataTextarea();

  // console.dir(inputSurveyData);
  print(Object.fromEntries(inputSurveyData));
}

function setSurveyDataCheckbox() {
  for (const name of nameSurveyCheckboxs) {
    const elChecked = document.querySelectorAll(`[name=${name}]:checked`) as NodeListOf<HTMLInputElement>;

    inputSurveyData.set(name, [...elChecked].length < 1 ? undefined : [...elChecked].map(el => el.value).join(','));
  }
}

function setServeyDataRadio() {
  for (const name of nameSurveyRadios) {
    const elChecked = document.querySelector(`[name=${name}]:checked`) as HTMLInputElement | null;

    inputSurveyData.set(name, elChecked?.value);
  }
}

function setSurveyDataTextarea() {
  for (const name of nameSurveyTextareas) {
    const el = document.querySelector(`[name=${name}]`) as HTMLTextAreaElement | null;

    inputSurveyData.set(name, el?.value || undefined);
  }
}

// 동의하기 전부? && 설문 전부? && 유저정보 전부? && 생일 유효성? && 핸드폰 유효성?
function isValidateAllInput() {
  try {
    isSettledAllInput();

    // checkValidationPhone();
    // checkValidationEmail();
    // checkValidationBirthDay();

    return true;
  } catch (error) {
    if (!isValidationError(error)) throw error;

    // 애러 처리
    handleValidationError(error);
    return false;
  }
}

function handleValidationError(error: ErrorWithMessage) {
  const { invalidType, message } = error;
  console.log('handleValidationError: ', invalidType, message);

  switch (invalidType) {
    // case INVLALID_BIRTH:
    //   elUserInfoBirth.focus();
    //   alert(message);
    // break;
    // case INVLALID_BIRTH_AGE:
    //   elUserInfoBirth.focus();
    //   alert(message);
    // break;
    // case INVLALID_EMAIL:
    //   elUserInfoEmail.focus();
    //   alert(message);
    // break;
    // case INVLALID_PHONE:
    //   elUserInfoPhone.focus();
    //   alert(message);
    // break;
    default:
      console.error(message);
      // alert(message);
      break;
  }
}

// 입력 할때마다 체크 하여 btnSubmit 활성화 여부 결정
function isSettledAllInput() {
  return /*isSettledCertResult() && */ isSettledAllAgreeChecked() && /*isSetteldAllUserinfo() && */ isSetteldAllSurvery();
}

/*
function isSettledCertResult() {
  if (!HAS_CERT_RESULT) {
    throw ({ invalidType: NO_SETTILE_CERT_RESULT, message: NO_SETTILE_CERT_RESULT_MEASSAGE });
  }

  return true;
}
*/


// 필수동의 다 '동의' 했나? (checkbox)
function isAgreeAllRequireCheckebox() {
  // 필수동의 checkbox
  const hasNoAgreeCheckbox = [...elAgreeCheckboxs].filter(e => !e.dataset.optional).some(e => !e.checked);
  return !hasNoAgreeCheckbox;
}

// 필수동의 다 '동의' 했나? (radio)
function isAgreeAllRequireRadio() {
  // 필수동의 radio
  const hasNoAgreeRadio = Array.from(new Set([...elAgreeRadios].filter(e => !e.dataset.optional).map(e => e.name))).some((name) => {
    const elTargetRadio = document.querySelector(`input[type="radio"][name="${name}"]:checked`) as HTMLInputElement | null;
    return elTargetRadio === null || elTargetRadio.value === 'notagree';
  });

  return !hasNoAgreeRadio;
}

// 선택동의 다 '동의' 했나? (checkbox)
function isAgreeAllOptionalCheckbox() {
  // 선택동의 checkbox
  const hasNoAgreeCheckbox = [...elAgreeCheckboxs].filter(e => e.dataset.optional).some(e => !e.checked);

  return (!hasNoAgreeCheckbox);
}

// 선택동의 다 '동의' 했나? (radio)
function isAgreeAllOptionalRadio() {
  // 선택동의 radio
  const hasNoAgreeRadio = Array.from(new Set([...elAgreeRadios].filter(e => e.dataset.optional).map(e => e.name))).some((name) => {
    const elTargetRadio = document.querySelector(`input[type="radio"][name="${name}"]:checked`) as HTMLInputElement | null;
    return elTargetRadio === null || elTargetRadio.value === 'notagree';
  });

  return (!hasNoAgreeRadio);
}

// 동의항목 다 '동의'든 '비동의'든 체크 했나?
function isJustSetteldAllAgree() {
  // 필수$선택 checkbox
  const hasNoCheckedAgreeCheckbox = [...elAgreeCheckboxs].some(e => !e.checked);

  // 필수&선택 radio
  const hasNoSelectAgreeRadio = Array.from(new Set([...elAgreeRadios].map(e => e.name))).some((name) => {
    const elTargetRadio = document.querySelector(`input[type="radio"][name="${name}"]:checked`) as HTMLInputElement | null;
    return elTargetRadio === null;
  });

  return (!hasNoCheckedAgreeCheckbox && !hasNoSelectAgreeRadio);
}


// 동의항목 전부 통과 했는지 확인 (필수&선택 동의든 비동의든 체크 && 필수 동의)
function isSettledAllAgreeChecked() {
  // 동의항목 다 '동의'든 '비동의'든 체크 했나?
  if (!isJustSetteldAllAgree()) {
    throw ({ invalidType: NO_SETTILE_AGREE, message: NO_SETTLE_AGREE_MEASSAGE });
  }
  // 필수동의 다 '동의' 했나? (checkbox)
  if (!isAgreeAllRequireCheckebox()) {
    throw ({ invalidType: NO_SETTILE_AGREE, message: NO_SETTLE_REQUIRED_AGREE_CHECKBOX_MEASSAGE });
  }
  // 필수동의 다 '동의' 했나? (radio)
  if (!isAgreeAllRequireRadio()) {
    throw ({ invalidType: NO_SETTILE_AGREE, message: NO_SETTLE_REQUIRED_AGREE_RADIO_MEASSAGE });
  }

  return true;
}

// function isSetteldAllUserinfo(){
//   const hasNoInputed = [...elUserInfo].some(e=>!e.value);
//   if(hasNoInputed) {
//     const noInputKeys =[...elUserInfo].filter(e=>!e.value).map(e=>e.name);

//     throw({invalidType: NO_SETTILE_USERINFO, message: `${NO_SETTLE_USERINFO_MEASSAGE}, ${noInputKeys}`});
//   }

//   return true;
// }

function isSetteldAllSurvery() {
  // const hasNoInputed = Array.from(inputSurveyData.values()).some(e => e === undefined);
  // const a = Array.from(inputSurveyData.entries());
  console.log(inputSurveyData);
  const hasNoInputed = Array.from(inputSurveyData.entries()).some(([name, value]) => {
    const ElInput = document.querySelector(`[name="${name}"]`) as HTMLElement;
    console.log(name, ElInput.dataset.optional, value);
    return !ElInput.dataset.optional && (!value || value.indexOf('null_extratext') > -1);
  });

  // const hasNoInputed = Array.from(new Set(([...elSurveyCheckboxs, ...elSurveyRadios, ...elSurveyTextAreas]).filter(e => !e.dataset.optional).map(e => e.name))).some((name) => {
  //   const elTarget = document.querySelector(`input[name="${name}"]`) as HTMLInputElement;
  //   console.log(elTarget.value);
  //   return !elTarget.value;
  // });
  if (hasNoInputed) {
    const noInputKeys = Array.from(inputSurveyData).filter(e => e[1] === undefined).map(e => e[0]);

    // throw({invalidType: NO_SETTILE_SURVEY, message: `${NO_SETTLE_SURVEY_MEASSAGE}, ${noInputKeys.join(', ')}`});
    // throw({invalidType: NO_SETTILE_SURVEY, message: `${NO_SETTLE_SURVEY_MEASSAGE}, ${noInputKeys[0]}`});
    throw ({ invalidType: NO_SETTILE_SURVEY, message: `${NO_SETTLE_SURVEY_MEASSAGE}` });
  }

  return true;
}


function isSetteldPagingSurvey(paging: number) {
  // const hasNoInputed = Array.from(inputSurveyData.values()).some(e => e === undefined);
  // const a = Array.from(inputSurveyData.entries());
  console.log(inputSurveyData);

  const elSurveyCheckboxs = [...elPageSection][paging].querySelectorAll('input.input-survey[type="checkbox"]') as NodeListOf<HTMLInputElement>;
  const elSurveyRadios = [...elPageSection][paging].querySelectorAll('input.input-survey[type="radio"]') as NodeListOf<HTMLInputElement>;
  const elSurveyTextAreas = [...elPageSection][paging].querySelectorAll('textarea.textarea-survey') as NodeListOf<HTMLTextAreaElement>;

  const nameSurveyCheckboxs = getInputNames(elSurveyCheckboxs);
  const nameSurveyRadios = getInputNames(elSurveyRadios);
  const nameSurveyTextareas = getInputNames(elSurveyTextAreas);

  const nameSurvey = [...nameSurveyCheckboxs, ...nameSurveyRadios, ...nameSurveyTextareas];

  const hasNoInputed = Array.from(inputSurveyData.entries()).some(([name, value]) => {
    const ElInput = document.querySelector(`[name="${name}"]`) as HTMLElement;
    console.log(name, ElInput.dataset.optional, value);
    return nameSurvey.includes(name) && !ElInput.dataset.optional && (!value || value.indexOf('null_extratext') > -1) ;
  });


  if (hasNoInputed) {
    // const noInputNames = Array.from(inputSurveyData).filter(e => e[1] === undefined).map(e => e[0]);
    // const firstNoInputNames = noInputNames[0];
    // const firstNoInputParentEl = (findParentWithClass(document.querySelector(`[name=${firstNoInputNames}]`)!, '.form-survey'));

    // firstNoInputParentEl && firstNoInputParentEl.scrollIntoView({ behavior: 'smooth' });
    // throw({invalidType: NO_SETTILE_SURVEY, message: `${NO_SETTLE_SURVEY_MEASSAGE}, ${noInputKeys.join(', ')}`});
    // throw({invalidType: NO_SETTILE_SURVEY, message: `${NO_SETTLE_SURVEY_MEASSAGE}, ${noInputKeys[0]}`});
    throw ({ invalidType: NO_SETTILE_SURVEY_CURRENT_PAGING, message: `${NO_SETTLE_SURVEY_CURRENT_PAGING_MEASSAGE}` });
  }

  return true;
}

function scrollToElement(element: HTMLElement) {
  element && element.scrollIntoView({ behavior: 'auto' });
  document.body.classList.contains('mobile') && window.scrollBy(0, -100);
}

function findParentWithClass(element: HTMLElement, selector: string) {
  let parent = element.parentElement;

  while (parent) {
    if (parent.matches(selector)) {
      return parent;
    }
    parent = parent.parentElement;
  }

  return null;
}
// async function confirmApply(){
//   return new Promise(res => {
//     showModal(true, 'confirm');

//     document.querySelector('.btn-modal-close')?.addEventListener('click', ()=> {
//       showModal(false, 'confirm');
//       res(false);
//     }, { once : true} );

//     document.querySelector('.btn-modal-cancel')?.addEventListener('click', ()=> {
//       showModal(false, 'confirm');
//       res(false);
//     }, { once : true} );

//     document.querySelector('.modal-dimmed')?.addEventListener('click', ()=> {
//       showModal(false, 'confirm');
//       res(false);
//     }, { once : true} );

//     document.querySelector('.modal-confirm .btn-modal-confirm')?.addEventListener('click', ()=> {
//       showModal(false, 'confirm');
//       res(true);
//     }, { once : true} );
//   });
// }

// async function confirmAlready(){
//   return new Promise(res => {
//     showModal(true, 'already');

//     document.querySelector('.modal-already .modal-dimmed')?.addEventListener('click', ()=> {
//       showModal(false, 'already');
//       res(true);
//     }, { once : true} );
//     document.querySelector('.modal-already .btn-modal-confirm')?.addEventListener('click', ()=> {
//       showModal(false, 'already');
//       res(true);
//     }, { once : true} );
//   });
// }

async function confirmConfirm(option: Record<string, any>) {
  const result = await ncuiConfirm.open(option);

  if (result.value === 'confirm') {
    return true;
  } else {
    return false;
  }
}


// async function confirmConfirm(targetSelector: string) {
//   return new Promise(res => {
//     showModal2(true, 'confirm', targetSelector);

//     document.querySelector('.btn-modal-close')?.addEventListener('click', () => {
//       if(!document.querySelector(targetSelector)) return; // ㅠㅠ

//       showModal2(false, 'confirm', targetSelector);
//       res(false);
//     }, { once: true });

//     document.querySelector('.btn-modal-cancel')?.addEventListener('click', () => {
//       if(!document.querySelector(targetSelector)) return;

//       showModal2(false, 'confirm', targetSelector);
//       res(false);
//     }, { once: true });

//     document.querySelector('.modal-dimmed')?.addEventListener('click', () => {
//       if(!document.querySelector(targetSelector)) return;

//       showModal2(false, 'confirm', targetSelector);
//       res(false);
//     }, { once: true });

//     document.querySelector(`${targetSelector} .btn-modal-confirm`)?.addEventListener('click', () => {
//       if(!document.querySelector(targetSelector)) return;

//       showModal2(false, 'confirm', targetSelector);
//       res(true);
//     }, { once: true });
//   });
// }

async function confirmAlert(targetSelector: string) {
  return new Promise(res => {
    showModal2(true, 'alert', targetSelector);

    document.querySelector('.modal-dimmed')?.addEventListener('click', () => {
      if(!document.querySelector(targetSelector)) return;

      showModal2(false, 'alert', targetSelector);
      res(true);
    }, { once: true });
    document.querySelector(`${targetSelector} .btn-modal-confirm`)?.addEventListener('click', () => {
      if(!document.querySelector(targetSelector)) return;

      showModal2(false, 'alert', targetSelector);
      res(true);
    }, { once: true });
  });
}


// function showModal(flag:boolean, target: 'confirm' | 'already'){
//   let elTargetModal: HTMLDivElement;

//   if(target === 'confirm'){
//     elTargetModal = elModalConfirm;
//   }else{
//     elTargetModal = elModalAlready;
//   }

//   if(flag){
//     document.body.style.height = '100%';
//     document.body.style.overflow = 'hidden';
//     elTargetModal.classList.add('is-show');
//     target === 'confirm' && elModalDimmed.classList.add('is-show');

//   }else{
//     document.body.style.height = '';
//     document.body.style.overflow = '';
//     elTargetModal.classList.remove('is-show');
//     target === 'confirm' && elModalDimmed.classList.remove('is-show');
//   }
// }


function showModal2(flag: boolean, type: 'confirm' | 'alert', targetSelector: string) {
  const elTargetModal = document.querySelector(targetSelector) as HTMLDivElement;

  if (flag) {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
    elTargetModal.classList.add('is-show');
    type === 'confirm' && elModalDimmed.classList.add('is-show'); // confirm 타입인 경우에만 딤드

  } else {
    document.body.style.height = '';
    document.body.style.overflow = '';
    elTargetModal.classList.remove('is-show');
    type === 'confirm' && elModalDimmed.classList.remove('is-show'); // confirm 타입인 경우에만 딤드
  }
}


// checkbox value에 no 가 있는 항목은 no 선택시 다른거 다 지움
function exceptNoneValue(event: Event) {
  const elTarget = event.target;
  if (!(elTarget instanceof HTMLInputElement)) return false;

  const isChecked = elTarget.checked;
  if (!isChecked) return false;

  const targetName = elTarget.name;
  const targetCheckboxs = document.querySelectorAll(`[name="${targetName}"]`) as NodeListOf<HTMLInputElement>;
  if (elTarget.value === 'none') {
    [...targetCheckboxs].filter(e => e.checked && e.value !== 'none').map(e => { e.checked = false; e.dispatchEvent(new Event('change')); });
  } else {
    [...targetCheckboxs].filter(e => e.checked && e.value === 'none').map(e => { e.checked = false; e.dispatchEvent(new Event('change')); });
  }
}


// 본인인증 callback API (pc) - 실패시 리로드
/*
async function checkCertAuthByCallback(authResult: string) {
  console.log('본인인증 callback API (pc) - 실패시 리로드', authResult);
  await checkCertAuth(authResult);
}

window.checkCertAuthByCallback = checkCertAuthByCallback;

// 본인인증 redirect API (mobile) - 실패시 리로드
async function checkCertAuthByQuery() {
  const paramsObj = Object.fromEntries(new URLSearchParams(location.search)); console.log(paramsObj);
  console.log('본인인증 redirect API (mobile) - 실패시 리로드', paramsObj.q);

  if (paramsObj.q) {
    await checkCertAuth(paramsObj.q);

    // 쿼리에서 q 빼고 히스토리 리플레이스
    delete paramsObj.q;
    const newQuery = new URLSearchParams(paramsObj).toString();
    window.history.replaceState(null, '', location.pathname + '?' + newQuery);
  }
}
*/

/*
// 본인인증 - authResult :
// 1) 진입시 쿼리스트링의 q 값이 있는경우
// 2) 본인인증 API가 콜백함수로 checkCertAuth 호출시 물고 들어오는 파라미터값
async function checkCertAuth(authResult: string) {
  try {
    console.log(authResult);
    // [TODO] 풀기
    const results = await callCheckAuth({
      authResult,
      eventCode: EVETN_CODE
    });

    // [TODO] 풀기
    HAS_CERT_RESULT = results.data.authResult;

    // HAS_CERT_RESULT = true;

    // [TODO] 삭제 - erroCode Test Code
    // throw {
    //   response:{
    //     data: {
    //       result: {
    //         'errorCode': 'cbt.cbt.selfCert.RESTRICTED_AGE',
    //         'errorMessageArgs':'' ,
    //         'exceptionClassName': 'DuplicateKeyException',
    //         'message': null,
    //         'object': null,
    //         'field': null,
    //         'displayableMessage': false
    //       }
    //     }
    //   }
    // };

    // 설문조사 가능
    setSurveyDisable();
    setCertArea();
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorData = (error).response?.data;
      if (!errorData) return false;

      const isUnder18ServerError = checkIsUnder18ServerError(errorData);
      const newQuery = getNewQueryWithoutQ();

      // 얼럿 출력후에

      // [TODO] 18세 미만인경우 따로 처리? => 합시다.
      if(isUnder18ServerError){
        await confirmConfirm('.modal-underage');
        location.href = window.urlInfoPage + '?' + newQuery;
      }else{
        displayErrorMessage(error);
        location.href = location.pathname + '?' + newQuery;
      }
    }
    throw error;
  }
}

// 'q' 서치파람 제거된 서치 파람
function getNewQueryWithoutQ(){
  const paramsObj = Object.fromEntries(new URLSearchParams(location.search));
  delete paramsObj.q;
  const newQuery = new URLSearchParams(paramsObj).toString();

  return newQuery;
}

// 18세 미만이라는 애러인경우
function checkIsUnder18ServerError(errorData: any){
  const ErrorResult = Array.isArray(errorData.result) ? errorData.result[0]: errorData.result;
  if(ErrorResult && ErrorResult.errorCode && ErrorResult.errorCode ===  'cbt.RESTRICTED_AGE'){
    return true;
  }
  return false;
}


// 본인인증 확인 된후 주소 세팅 하는것 => 세팅 하지 않음
// function setInitAddress(add1: string, add2: string){
//   elCertAddress1.value = add1;
//   elCertAddress1.dispatchEvent(new Event('change'));
//   elCertAddress1.value = add2;
//   elCertAddress1.dispatchEvent(new Event('change'));
// }

*/

function getAPIData() {
  const data: RequestPostSurveyData = {
    eventCode: EVETN_CODE,
    surveyNo: SURVEY_NO,
    // agreeFlag: isSettledAllAgreeChecked(), // 약관 동의 여부
    // agreeFlag: isAgreeAllRequireCheckebox() && isAgreeAllRequireRadio(), // 약관 동의 여부
    // selectAgreeFlag: isAgreeAllOptionalCheckbox() && isAgreeAllOptionalRadio(), // 선택 동의 여부
    /*
    address1: elCertAddress1.value,
    address2: elCertAddress2.value,
    */

    //설문항목
    survey: JSON.stringify(Object.fromEntries([...inputSurveyData].map(([key, value]) => {
      // 선택 항목이 생기는 바람에...JSON.stringfy는 object에 undefined가 있으면 제거 해버린다. 그거 방지 하기 위한 코드
      if (value === undefined) {
        return [key, ''];
      } else {
        return [key, value];
      }
    })))
  };

  console.log('getAPIData: ', data);

  return data;
}

function isValidationError(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string' &&
    typeof (error as Record<string, unknown>).invalidType === 'string'
  );
}

async function showMarketingApplyAlert(flag: boolean) {
  const subClassName = flag && 'modal-apply-marketing' || 'modal-apply-marketing';

  // 만들어서 붙이기
  const El = makeMarketingApplyAlertElement(flag, subClassName);
  document.body.append(El);

  // 보여주기
  await confirmConfirm({title:''});

  // 지우기
  El.remove();
}

function makeMarketingApplyAlertElement(flag: boolean, subClassName: string) {

  const El = document.createElement('div');

  El.classList.add('modal-alert', subClassName);

  El.innerHTML = `
    <p class="btn-modal-desc">[NCSOFT] ${getTodayKo()} 광고성<br>정보 수신에 ${flag && '동의' || '동의를 철회'}하였습니다.</p>
    <div class="btn-modal-confirm">확인</div>
  `;

  return El;
}


function getTodayKo() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줍니다.
  const day = today.getDate();

  const formattedDate = `${year}년 ${month}월 ${day}일`;

  return formattedDate;
}


type ErrorWithMessage = {
  invalidType: typeof INVLALID_PHONE | typeof INVLALID_EMAIL | typeof INVLALID_BIRTH | typeof INVLALID_BIRTH_AGE | typeof NO_SETTILE_SURVEY | typeof NO_SETTILE_AGREE | typeof NO_SETTILE_CERT_RESULT
  message: string
}

function setAnchorTagHrefWithcUrrentParam() {
  [...document.querySelectorAll('a')].map(ElAnchor => setAnchorTagWithParams(ElAnchor));
}

async function onClickBtnNextPage() {
  try {
    isSetteldPagingSurvey(CURRENT_PAGE); // 페이지 내에 있는 설문 다했나?
    setPaging(CURRENT_PAGE + 1);
  } catch (error) {
    // alert(err);
    if (!isValidationError(error)) throw error;


     ncuiToast.open({
      // customClass: 'login-alert',
      showCloseButton: false,
      showConfirmButton: false,
      isVertical: false,
      title: NO_SETTLE_SURVEY_CURRENT_PAGING_MEASSAGE,
      // position: 'top',
      timer: 1500,
    });

    const noInputNames = Array.from(inputSurveyData).filter(e => e[1] === undefined ||  e[1].indexOf('null_extratext') > -1 ).map(e => e[0]);

    const firstNoInputNames = noInputNames[0];
    const firstNoInputParentEl = (findParentWithClass(document.querySelector(`[name=${firstNoInputNames}]`)!, '.form-survey'))!;

    scrollToElement(firstNoInputParentEl);

    // handleValidationError(error);

  }
}

function onClickBtnPrevPage() {
  setPaging(CURRENT_PAGE - 1);
}

// 지금 페이지에 따라 화면 세팅
function setPaging(pageNumber: number) {
  CURRENT_PAGE = pageNumber;

  displayPagingNavigator();
  displayBackButton();
  displayPagingSection();
  setDisablePagingNavigator();
  displayPagingNumber();
  displayBtnSubimt(CURRENT_PAGE);


  window.scroll({ top: 0, behavior: 'smooth', });
}
function displayBtnSubimt(CURRENT_PAGE: number){
  const TOTAL_PAGE = [...elPageSection].length;
  const flag = TOTAL_PAGE === CURRENT_PAGE + 1;
  const ElSectionBot =  document.querySelector('.section-bot') as HTMLDivElement;

  console.log(CURRENT_PAGE + 1,TOTAL_PAGE );
  if(flag){
    ElSectionBot.style.display = '';
  }else{
    ElSectionBot.style.display = 'none';
  }
}

function setDisablePagingNavigator() {
  try {
    isSetteldPagingSurvey(CURRENT_PAGE);

    togglePagingNavigatorDisable(false);
  } catch (error) {
    if (!isValidationError(error)) throw error;

    togglePagingNavigatorDisable(true);

    handleValidationError(error);
  }
}

function togglePagingNavigatorDisable(isDisable: boolean) {
  if (isDisable) {
    elBtnPrevPage.classList.add('is-disable');
    elBtnNextPage.classList.add('is-disable');
  } else {
    elBtnPrevPage.classList.remove('is-disable');
    elBtnNextPage.classList.remove('is-disable');
  }
  // elBtnPrevPage.disabled = !isAble;
  // elBtnNextPage.disabled = !isAble;
}

function displayBackButton(){
  const _CURRENT_PAGE = CURRENT_PAGE + 1;
  if(_CURRENT_PAGE !== 1){
    (document.querySelector('.btn-back-wrap') as HTMLElement)!.style.position = 'relative';
    (document.querySelector('.btn-back-wrap') as HTMLElement)!.style.left = '-10000px';
  }else{
    (document.querySelector('.btn-back-wrap') as HTMLElement)!.style.position = '';
    (document.querySelector('.btn-back-wrap') as HTMLElement)!.style.left = '';
  }
}
function displayPagingNavigator() {
  const TOTAL_PAGE = [...elPageSection].length;
  const _CURRENT_PAGE = CURRENT_PAGE + 1;

  if (_CURRENT_PAGE === 1 && TOTAL_PAGE > 1) {
    elBtnPrevPage.style.display = 'none';
    elBtnNextPage.style.display = '';
  } else if (_CURRENT_PAGE === 1 && TOTAL_PAGE === 1) {
    elBtnPrevPage.style.display = 'none';
    elBtnNextPage.style.display = 'none';
  } else if (_CURRENT_PAGE  >= TOTAL_PAGE) {
    elBtnPrevPage.style.display = '';
    elBtnNextPage.style.display = 'none';
  } else {
    elBtnPrevPage.style.display = '';
    elBtnNextPage.style.display = '';
  }
}

function displayPagingSection() {
  [...elPageSection].map(el => el.style.display = 'none');

  [...elPageSection][CURRENT_PAGE].style.display = 'block';
}

function displayPagingNumber(){
  const TOTAL_PAGE = [...elPageSection].length;

  if(TOTAL_PAGE <= 1){
    return ;
  }

  const template = `
    <div>
      <span>${CURRENT_PAGE + 1}</span> / <span>${TOTAL_PAGE}</span>
    </div>
  `;

  elPageInfo.innerHTML = template;


}

const _A = [1] as const;
const _B = [1,2,3] as const;

const a: typeof _A | typeof _B = [1,2,3];

a.includes(1);

function createForm(datas: (typeof dataSuervey2)[number] | (typeof dataSuervey1)[number]) {
  return datas.map((data, idx) => {
    const inputType = (data.value as any).includes('서술형') ? 'onlyText' : 'checkbox';

    const surveyIdx = data.surveyIdx;

    if (inputType === 'checkbox') {
      if(data.word[0]){

        return `
        <div class="form-survey form-survey-checkbox ${((data.value) as readonly unknown[]).includes('경험해 보지 못 했다.') ? 'form-survey-checkbox-outside' : '' }" data-check-max="${data.max}">
          <p><span>${surveyIdx}.&nbsp;&nbsp;</span><span>${data.title}</span></p>
          <hr>
            <div class="ui-checkbox-wrap ui-checkbox-wrap-row">
              ${createCheckbox(data.value, surveyIdx, true)}
            </div>
            <div class="word-wrap">
               <p>${data.word[0]} </p>
               <p>${data.word[1]}</p>
            </div>

          </div>
        `;
      }else{
        return `
        <div class="form-survey form-survey-checkbox" data-check-max="${data.max}">
        <p><span>${surveyIdx}.&nbsp;&nbsp;</span><span>${data.title}</span></p>
          <hr>
          <div class="ui-checkbox-wrap">
          ${createCheckbox(data.value, surveyIdx)}
          </div>
        </div>
        `;
      }

    } else if (inputType === 'onlyText') {
      return `
      <div class="form-survey form-survey-textarea">
      <p><span>${surveyIdx}.&nbsp;&nbsp;</span><span>${data.title}</span></p>
      <hr>
      <div>
          <textarea class="textarea-survey" name="survey-${surveyIdx}" id="" maxlength="1000" placeholder="자유롭게 작성해주세요."></textarea>
      </div>
    </div>
      `;
    }
  }).join('');
}

function createCheckboxNum(values: readonly any[], surveyIdx: number) {
  return values.map((value, idx) => {
    return `
    <div class="ui-checkbox ui-checkbox-etc-text">
      <input class="input-survey" type="checkbox" name="survey-${surveyIdx}" id="survey-${surveyIdx}-${idx}" value="null_extratext">
      <label for="survey-${surveyIdx}-${idx}">
          <div class="custom-box"></div>
          <span class="label-text">${value}</span>
      </label>
      <textarea class=" checkbox-etc-text" data-target-input="survey-${surveyIdx}"" name="survey-${surveyIdx}"-etc" id="" maxlength="1000" placeholder="간단하게 작성해주세요."></textarea>
    </div>
    `;
  });
}

function createCheckbox(values: readonly any[], surveyIdx: number, isOutside = false) {
  return values.map((value, idx) => {
    if (!value) {
      return '';
    } else if (value === '기타(간단하게 작성해주세요.)' || value === '기타(작성 가능)' || value === '기타' || value === '기타(') {
      return `
        <div class="ui-checkbox ui-checkbox-etc-text">
          <input class="input-survey" type="checkbox" name="survey-${surveyIdx}" id="survey-${surveyIdx}-${idx}" value="null_extratext">
          <label for="survey-${surveyIdx}-${idx}">
              <div class="custom-box"></div>
              <span class="label-text">${value}</span>
          </label>
          <textarea class=" checkbox-etc-text" data-target-input="survey-${surveyIdx}"" name="survey-${surveyIdx}"-etc" id="" maxlength="1000" placeholder="간단하게 작성해주세요."></textarea>
        </div>
        `;
    } else if (isOutside && value === '경험해 보지 못 했다.') {
      return `
      <div class="ui-checkbox ui-checkbox-outsideRadio">
        <input class="input-survey" type="checkbox" name="survey-${surveyIdx}" id="survey-${surveyIdx}-${idx}" value="${idx + 1}">
        <label for="survey-${surveyIdx}-${idx}">
            <div class="custom-box"></div>
            <span class="label-text">${value}</span>
        </label>
      </div>
      `;
    } else if (!isNaN(Number(value))) {
      return `
      <div class="ui-checkbox ui-checkbox-number">
        <input class="input-survey" type="checkbox" name="survey-${surveyIdx}" id="survey-${surveyIdx}-${idx}" value="${idx + 1}">
        <label for="survey-${surveyIdx}-${idx}">
            <div class="custom-box"></div>
            <span class="label-text">${value}</span>
        </label>
      </div>
      `;
    } else {
      return `
        <div class="ui-checkbox">
          <input class="input-survey" type="checkbox" name="survey-${surveyIdx}" id="survey-${surveyIdx}-${idx}" value="${idx + 1}">
          <label for="survey-${surveyIdx}-${idx}">
              <div class="custom-box"></div>
              <span class="label-text">${value}</span>
          </label>
        </div>
        `;
    }
  }).join('');
}


// function createFormData(){
//   const template = createForm(data);
//   const TempEl = document.createElement('div') ;
//   TempEl.innerHTML = template;

//   document.querySelector('.section-page.section-page1 .section-page-top')!.innerHTML = template;
// }

const tempSubmitBtn = `
    <p>모든 항목을 입력 후 신청이 가능합니다.</p>
    <button class="btn-submit">신청하기</button>
`;

const form1LastSurveyPage = 3;
const form2LastSurveyPage = 1;


function creatSectionPage(totalPage: number){
  let _temp = '';

  for(let i = 1; i <=totalPage; i++ ){
    _temp+=`
      <div class="section-page section-page${i}"></div>
    `;
  }

  document.querySelector('.form-wrap')!.innerHTML = _temp;

}

function createFormData(datas:(typeof dataSuervey1) |  typeof dataSuervey2) {
  creatSectionPage(datas.length);

  datas.forEach((data, idx) => {
    document.querySelector(`.section-page${idx + 1}`)!.innerHTML = createForm(data);
  });

  // const tempBtnSubmitWrap = document.createElement('div');
  // tempBtnSubmitWrap.classList.add('btn-submit-wrap');
  // tempBtnSubmitWrap.innerHTML = tempSubmitBtn;
  // document.querySelector(`.section-page${form1LastSurveyPage}`)!.append(tempBtnSubmitWrap);

}

function createFormData2(datas: typeof dataSuervey2) {
  datas.forEach((data, idx) => {
    document.querySelector(`.section-page${idx + 1}`)!.innerHTML = createForm(data);
  });

  // const tempBtnSubmitWrap = document.createElement('div');
  // tempBtnSubmitWrap.classList.add('btn-submit-wrap');
  // tempBtnSubmitWrap.innerHTML = tempSubmitBtn;
  // document.querySelector(`.section-page${form2LastSurveyPage}`)!.append(tempBtnSubmitWrap);
}
